import ExtratoContaCorrente from '../../spa/conta-corrente/extrato/ExtratoContaCorrente';

export default {
  path: 'extrato-conta-corrente',
  name: 'extrato-conta-corrente',
  component: ExtratoContaCorrente,
};
